export * from './shared-pipe.module';